<template mode="out-in">
	<div>
		<img src="../assets/fanhui.png"
			style="position: absolute; width: 1.5%; left: 1.5%;top: 3.5%; cursor: pointer; z-index: 9999;" @click="$router.go(-1)">
		<dv-border-box-11 title="物流可视化平台" class='echart'>
			<div class="box">
				<div class="echart_left">
					<dv-border-box-10 class="left_top">
						<dv-loading v-show='left_top_loading'>Loading...</dv-loading>
						<div v-show="left_top_text">
							<h2>本月汽车运输车次的总量</h2>
							<!-- <dv-digital-flop :config="car_time1" class='cartime' /> -->
							<h2 class="cartime">{{carTime +' 次'}}</h2>
							<h2>
								{{monthTimesText}}
								<img src="../assets/img/downlogo.png" v-show="downlogo">
								<img src="../assets/img/uplogo.png" v-show="uplogo">
								{{monthTimesIncrease}}
							</h2>
						</div>
					</dv-border-box-10>
					<dv-border-box-10 class="left_center">
						<dv-loading v-show='left_center_loading'>Loading...</dv-loading>
						<div v-show="left_center_text" class="left_center_text">
							<h2>本月运输完成率</h2>
							<div id="chart1"></div>
						</div>
					</dv-border-box-10>
					<dv-border-box-10 class="left_bottom">
						<dv-loading v-show='left_bottom_loading'>Loading...</dv-loading>
						<div v-show="left_bottom_text" class="left_bottom_text">
							<h2>各站台季度运输次数</h2>
							<div id="chart2"></div>
						</div>
					</dv-border-box-10>
				</div>
				<div class="echart_center"></div>
				<div class="echart_right">
					<dv-border-box-10 class="right_top">
						<div v-show="config1_text" style="text-align: center;">
							No paln for day
						</div>
						<dv-loading v-show='config1_loading'>Loading...</dv-loading>
						<dv-scroll-board :config="config1" v-show='config1_form' class='config1_form' />
					</dv-border-box-10>
					<dv-border-box-10 class="right_bottom">
						<dv-loading v-show='config2_loading'>Loading...</dv-loading>
						<dv-scroll-board :config="config2" v-show='config2_form' class='config2_form' />
					</dv-border-box-10>
				</div>
			</div>
		</dv-border-box-11>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import axios from 'axios'
	// import qs from 'qs'
	export default {
		data() {
			return {
				token: '',
				incomplete: '',
				allcomplete: '',
				complete: '',
				carTime: '', //车次的总量
				monthTimesIncrease: '', //环比增长
				StationCode: [],
				StationValue: [],
				Station: [],
				Station_code: [],
				monthTimesText: '',
				uplogo: false,
				downlogo: false,
				config1: {},
				config2: {},
				config1_form: true,
				config1_loading: false,
				config2_form: true,
				config2_loading: false,
				config2_data: [],
				config1_data: [],
				config1_text: false,
				left_top_text: true,
				left_top_loading: false,
				left_center_text: true,
				left_center_loading: false,
				left_bottom_text: true,
				left_bottom_loading: false,
				todayList: [],
				today: new Date(),
				url: this.$store.state.bigscreen,
				getToMonth: [],
				getToDay: []
			}
		},
		mounted() {
			console.log('55555')
			this.chart1()
			this.chart2()
			this.car_time1 = this.car_time2
		},
		created() {
			
			this.GetToMonthPlan()
			setInterval(() => {
				this.config1_loading = true
				this.config2_loading = true
				this.left_top_loading = true
				this.left_center_loading = true
				this.left_bottom_loading = true
				this.left_top_text = false
				this.left_center_text = false
				this.left_bottom_text = false
				this.config1_form = false
				this.config2_form = false
				this.chart1()
				this.chart2()
				this.GetToMonthPlan()
			}, 600000)
		},
		methods: {
			//运输次数
			GetToMonthPlan() {
				this.config1_data = []
				this.config2_data = []
				axios({
					method: 'get',
					url: this.url + 'GetToMonthPlan',
				}).then((res) => {
					this.carTime = res.data.Count
					this.getToMonth = res.data.Data
					this.getToDay = res.data.Data
					if (res.data.Message == '请求成功') {
						axios({
							method: 'get',
							url: this.url + 'GetToMonthPlanCount',
						}).then((res) => {
							// console.log(res.data.Count)
							if (res.data.Message == '请求成功') {
								setTimeout(() => {
									this.left_top_loading = false
									this.left_top_text = true
								}, 3000)
								if (res.data.Data[0].value == 0) {
									this.monthTimesText = '环比增加'
									this.uplogo = true
									this.downlogo = false
									this.monthTimesIncrease = res.data.Data[1].value + '00%'
								} else if (res.data.Data[1].value == 0) {
									this.monthTimesText = '环比减少'
									this.downlogo = true
									this.uplogo = false
									this.monthTimesIncrease = res.data.Data[1].value + '00%'
								} else if (res.data.Data[1].value == res.data.Data[0].value) {
									this.downlogo = false
									this.uplogo = false
									this.monthTimesText = '环比没有变化'
								} else {
									var str = res.data.Data[1].value / res.data.Data[0].value
									if (str > 1) {
										this.monthTimesText = '环比增加'
										this.uplogo = true
										this.monthTimesIncrease = Number((str - 1) * 100).toFixed(2) +
											'%'
									} else {
										this.monthTimesText = '环比减少'
										this.downlogo = true
										this.monthTimesIncrease = Number((1 - str) * 100).toFixed(2) +
											'%'
									}
								}
							}
						})
						//获取当月运输计划
						console.log(this.getToMonth)
						this.getToMonth.forEach((i) => {
							switch (i.State) {
								case 0:
									i.State = '待审核'
									break;
								case 1:
									i.State = '待确认'
									break;
								case 2:
									i.State = '配送中'
									break;
								case 3:
									i.State = '已到达'
									break;
								case 4:
									i.State = '已完成'
									break;
								case 5:
									i.State = '终止计划'
									break;
								case -2:
									i.State = '删除'
									break;
								case -1:
									i.State = '未通过'
									break;
								default:
							}
							this.config2_data.push([i.LicensePlate, i.DriverName, i.OriginAddress, i
								.State
							])
							this.config2 = {
								header: ['车牌号', '司机', '原单位', '运输状态'],
								data: this.config2_data,
								headerBGC: '#041434',
								oddRowBGC: '#051a34',
								evenRowBGC: '#2b4578',
								waitTime: 1500,
								hoverPause: true
							}
						})
						setTimeout(() => {
							this.config2_loading = false
							this.config2_form = true
						}, 3000)


						//获取当日计划
						if (this.getToDay.length == 0) {
							this.config1_text = true
						} else {
							this.config1_text = false
						}
						this.getToDay.forEach((i) => {
							var a = i.UpdateTime.replace('T', ' ')
							this.config1_data.push([i.OrderNum, i.Name, a, i.StationCode])
							this.config1 = {
								header: ['订单号', '名称', '时间', '站台'],
								data: this.config1_data,
								headerBGC: '#041434',
								oddRowBGC: '#051a34',
								evenRowBGC: '#2b4578',
								waitTime: 1500,
								hoverPause: true,
								columnWidth: [150, 100, 200, 80]
							}
						})
						setTimeout(() => {
							this.config1_loading = false
							this.config1_form = true
						}, 3000)
					}
				})
			},
			chart1() {
				// console.log(this.token)
				axios({
					method: 'get',
					url: this.url + 'GetToMontProgress',
				}).then((res) => {
					// console.log(res.data.Count)
					if (res.data.Message == '请求成功') {
						setTimeout(() => {
							this.left_center_loading = false
							this.left_center_text = true
						}, 3000)
						this.incomplete = res.data.Data[0].value - res.data.Data[1].value
						this.complete = res.data.Data[1].value
						this.allcomplete = res.data.Data[0].value
						var text =  Number((this.complete / this.allcomplete) * 100).toFixed(2)
						if(this.complete==0&&this.allcomplete==0){
							text = 0
						}
						let chart1 = echarts.init(document.getElementById('chart1'));
						let option1 = {
							color: [
								'#eecb5f', '#7ecf51'
							],
							title: {
								text: text + '%',
								x: 'center',
								y: 'center',
								textStyle: {
									fontSize: 30,
									color: '#fff'
								}
							},
							tooltip: {
								trigger: 'item',
								formatter: '{b} : {c} ({d}%)'
							},
							toolbox: {
								show: true,
							},
							series: [{
								type: 'pie',
								radius: [80, 100],
								roseType: 'radius',
								label: {
									show: false
								},
								emphasis: {
									label: {
										show: true
									}
								},
								data: [{
										value: this.complete,
										name: '已完成'
									},
									{
										value: this.incomplete,
										name: '未完成'
									},
								]
							}, ]
						};
						chart1.clear()
						chart1.setOption(option1);
						window.onresize = function() {
							chart1.resize()
						}
					}
				})
			},
			chart2() {
				this.Station = []
				this.Station_code = []
				axios({
					method: 'get',
					url: 'http://vrs.wenxingkeji.net/GetStation',
				}).then((res) => {
					// console.log(res.data.Data)
					if (res.data.Message == '请求成功') {
						res.data.Data.forEach((n) => {
							this.Station.push(n.StationCode)
						})
						console.log(this.Station)
						axios({
							method: 'get',
							url: this.url + 'GetStationPlanNum',
						}).then((res) => {
							if (res.data.Message == '请求成功') {
								res.data.Data.forEach((i) => {
									this.StationCode.push(i.name)
								})
								for (let i = 0; i < this.Station.length; i++) {
									for (let r = 0; r < res.data.Data.length; r++) {
										if (this.Station[i] == res.data.Data[r].name) {
											this.Station_code[i] = res.data.Data[r].value
										}
									}
								}
								// console.log(this.StationValue)
								let chart2 = echarts.init(document.getElementById('chart2'));
								let option2 = {
									tooltip: {
										trigger: 'axis',
										axisPointer: {
											type: 'shadow'
										}
									},
									grid: {
										top: '8%',
										left: '3%',
										right: '4%',
										bottom: '12%',
										containLabel: true
									},
									xAxis: [{
										type: 'category',
										data: this.Station,
										axisTick: {
											alignWithLabel: true
										},
										axisLabel: {
											interval: 0, //x轴数据间隔
										},
										axisLine: {
											lineStyle: {
												color: '#fff'
											}
										},
									}],
									yAxis: [{
										type: 'value',
										axisLine: {
											lineStyle: {
												color: '#fff'
											}
										},
										splitLine: {
											show: true,
											lineStyle: {
												color: ['#262d35'],
											}
										}
									}],
									series: [{
										name: '运输次数',
										type: 'bar',
										barWidth: '60%',
										data: this.Station_code,
										itemStyle: {
											normal: {
												color: '#5689ee'
											}
										}
									}],
									dataZoom: [{
										type: 'slider',
										show: true,
										xAxisIndex: [0],
										left: '9%',
										bottom: -5,
										start: 0,
										end: 70
									}]
								};
								chart2.clear()
								chart2.setOption(option2);
								window.onresize = function() {
									chart2.resize()
								}
								setTimeout(() => {
									this.left_bottom_loading = false
									this.left_bottom_text = true
								}, 3000)
							}
						})
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	@border: 1px solid green;

	* {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	.echart {
		width: 100vw;
		height: 100vh;
		padding: 70px 30px 30px 30px;
		color: #fff;
		background-image: url(../assets/background.png);
	}

	.box {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;

		.echart_left {
			flex: 3;
			display: flex;
			flex-direction: column;

			.left_top {
				flex: 2;
				margin-bottom: 20px;
				padding: 10px;

				.cartime {
					color: #038abe;
					font-size: 36px;
					height: 50px;
				}
			}

			.left_center {
				flex: 4;
				padding: 10px;
				margin-bottom: 20px;

				.left_center_text {
					width: 100%;
					height: 100%;

					#chart1 {
						width: 100%;
						height: 100%;
					}
				}
			}

			.left_bottom {
				flex: 4;
				padding: 10px;

				.left_bottom_text {
					width: 100%;
					height: 100%;

					#chart2 {
						width: 100%;
						height: 100%;
					}
				}
			}
		}

		.echart_center {
			flex: 4;
		}

		.echart_right {
			flex: 3;
			display: flex;
			flex-direction: column;

			.right_top {
				flex: 3;
				padding: 10px;
				margin-bottom: 20px;

				.config1_form {
					width: 100%;
					height: 100%;
				}
			}

			.right_bottom {
				flex: 7;
				padding: 10px;

				.config2_form {
					width: 100%;
					height: 100%;
				}
			}
		}
	}
</style>
